import clsx from 'clsx';
import React, {} from 'react';
const HintContent = ({ children, className, marginBottom = false }) => (React.createElement("span", { className: clsx('hint--content', className, { 'remove-margin-bottom': !marginBottom }) }, children));
export default HintContent;
